import flatten from 'lodash/fp/flatten';
import { FC } from 'react';

import { CategoriesList, RowWrapper, Title } from './Wrapper';
import { CategoryRowProps } from './types';

const CategoryRow: FC<CategoryRowProps> = ({
  list,
  label,
  pageCategory,
  renderCategoryLink
}) => {
  const title = `Browse templates by ${label.toLowerCase()}`;
  const flatList = flatten(list);

  return (
    <RowWrapper>
      <Title {...{ title }} level={3} />
      <CategoriesList>
        {flatList.map(props => renderCategoryLink({ ...props, pageCategory }))}
      </CategoriesList>
    </RowWrapper>
  );
};

export default CategoryRow;
